<div class="ap-bg-info">
  <div class="ap-container ap-pt-1 ap-pb-3  ap-txt-center" [formGroup]="form" [ngSwitch]="displayOption">
    <ng-container *ngSwitchCase="'Search'">
      <h3>{{ checkBinLabel }}</h3>
      <div class="ap-spinner-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'Bin'">
      <h3>{{ title }}</h3>
      <mat-form-field class="ap-bin-field">
        <mat-label>{{ binLabel }}</mat-label>
        <div class="ap-inputButton">
          <input inputmode="numeric" pattern="\d*" #binInput matInput apNumbersOnly formControlName="binNumber" maxlength="6" (keydown)="onKeydown($event)" (keyup.enter)="binCheck()" autocomplete="false" [ngClass]="{'errorInput':noBinError}">
          <mat-icon *ngIf="!noBinError" (click)="binCheck()">keyboard_arrow_right</mat-icon>
          <mat-icon *ngIf="noBinError" class="ap-close-icon" (click)="clearBin()" >close</mat-icon>
        </div>
        <mat-error class="ap-txt-primary" *ngIf="binNumberControl.touched && binNumberControl.invalid && !binNumberControl.hasError('no-bin')  && !binNumberControl.hasError('alternative-bin')">{{validationMessages.binRequired | contentParse}}</mat-error>
        <mat-error class="ap-txt-primary" *ngIf="binNumberControl.touched && binNumberControl.hasError('no-bin')">{{validationMessages.binInvalid | contentParse}}</mat-error>       
      </mat-form-field>
      <mat-error class="ap-txt-primary" *ngIf="binNumberControl.touched && binNumberControl.hasError('alternative-bin')">{{validationMessages.alternativeBinNumber | contentParse}}</mat-error>
      <div [innerHtml]="selectCardFromLabel|safeHtml"></div>
    </ng-container>

    <ng-container *ngSwitchCase="'Card'">
      <h4 *ngIf="binNumberControl.valid">
        {{ binNumberControlHeader }}
        <span class="ap-bin-text">
          {{ this.form.get('binNumber').value }}
        </span>
      </h4>
      <h3 *ngIf="binNumberControl.invalid">{{ title }}</h3>
        <mat-form-field class="ap-card-select-field">
          <mat-label>{{ cardSelectLabel }}</mat-label>
          <mat-select #cardSelectInput formControlName="cardType" (selectionChange)="onSelectionChanged($event)" (openedChange)="onDropdown($event)">
            <mat-option *ngFor="let cardType of cards" [value]="cardType">
              {{ cardType.description }}
            </mat-option>
          </mat-select>
          <mat-error>{{validationMessages.cardNotSelected}}</mat-error>
        </mat-form-field>
        <button class="ap-card-submit ap-btn ap-btn-primary" *ngIf="showButton" (click)="submit()" [disabled]="cardTypeControl.invalid">Let's go</button>
      <div [innerHtml]="resetCardLabel|safeHtml">
      </div>
    </ng-container>
  </div>
</div>
